import React from 'react';
import { connect } from 'react-redux';
import { Navbar, Container } from 'react-bootstrap';
import BrandLogo from '../shared/BrandLogo';

import HeaderLoggedOutMobile from "./HeaderLoggedOutMobile.js";
import HeaderLoggedOutDesktop from "./HeaderLoggedOutDesktop.js";
import HeaderLoggedInDesktop from "./HeaderLoggedInDesktop.js";
import HeaderLoggedInMobile from "./HeaderLoggedInMobile.js";

const Header = ({auth}) => {

    // Check localStorage first for immediate UI response
    const isAuthenticatedLocal = localStorage.getItem('isAuthenticated') === 'true';
    
    // Show logged-in header only if we have both localStorage AND actual auth data
    // This prevents showing logged-in components when auth data is still loading
    const shouldShowLoggedIn = isAuthenticatedLocal && auth && auth.user && auth.user.permission && auth.user.id;
    
    // If localStorage says authenticated but no auth data yet, show basic header
    if (isAuthenticatedLocal && (!auth || !auth.user || !auth.user.permission || !auth.user.id)) {
        return (
            <>   
                {/*MOBILE*/}
                <div className="d-block d-lg-none mb-3">
                    <Navbar fixed="top" collapseOnSelect expand="md" variant="dark" className="navbar-glass">
                        <Container fluid>
                                                    <Navbar.Brand>
                            <BrandLogo linkTo="/dashboard" />
                        </Navbar.Brand>
                        </Container>
                    </Navbar>
                </div>
    
                {/*DESKTOP*/}
                <div className="d-lg-block d-none mb-3">
                    <Navbar fixed="top" collapseOnSelect expand="lg" variant="dark" className="navbar-glass">
                        <Container fluid>
                                                    <Navbar.Brand>
                            <BrandLogo />
                        </Navbar.Brand>
                        </Container>
                    </Navbar>
                </div>
            </>
        );
    }
    
    if (shouldShowLoggedIn) {
        return (
            <>   
                {/*MOBILE*/}
                <HeaderLoggedInMobile />
    
                {/*DESKTOP*/}
                <HeaderLoggedInDesktop />
            </>
        );
    } else {
        return (
            <>   
                {/*MOBILE*/}
                <HeaderLoggedOutMobile />
    
                {/*DESKTOP*/}
                <HeaderLoggedOutDesktop />
            </>
        );
    }        
}

function mapStateToProps({auth}) {
    return { auth };
}

export default connect(mapStateToProps)(Header);